// @ vendors
const Immutable = require('immutable');
// @ constants
const actionTypes = require('constants/actionTypes');
// @ commons
import { formatText } from 'core/i18n';

const setInitialState = () => {
    return Immutable.Map().merge({
        productsDescription: null,
        products: [],
        creditCardPrecontractual: null,
        productsDescriptionOpenCredit: '',
        partner: null,
    });
};

const initialState = setInitialState();

const products = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case actionTypes.LOAD_PRODUCTS:
            if (action.data) {
                let products = state.get('products');
                let id = 0;
                let accountType = 0;
                let productsDescription = '';
                let productsDescriptionOpenCredit = '';
                let creditCardPrecontractual = state.get('creditCardPrecontractual')
                    ? state.get('creditCardPrecontractual')
                    : null;
                let dataProducts = action.data.products;

                if (dataProducts) {
                    const invite = state.get('invite');

                    if (invite && invite.size && !invite.get('openDebitCard')) {
                        dataProducts = dataProducts.filter(product => product.description !== 'products-openDebitCard');
                    }

                    dataProducts.forEach(product => {
                        const cardDesignUrl = product.cardConfig ? product.cardConfig.cardDesignUrl : null;
                        let title;
                        let text;
                        let description = product.description;

                        switch (description) {
                            case 'products-openCurrentAccount':
                                title = formatText(product.description);
                                text = 'products-textCurrentAccount';
                                break;

                            case 'products-openDebitCard':
                                title = formatText(product.description);
                                text = 'products-textOpenDebit';
                                break;

                            case 'products-payrollAccount':
                                title = formatText(product.description);
                                text = 'products-textPayrollAccount';
                                accountType = 1;
                                break;

                            case 'products-welcomeAccount':
                                title = formatText(product.description);
                                text = 'products-textDefault';
                                accountType = 2;
                                break;

                            case 'products-payrollWelcomeAccount':
                                title = formatText(product.description);
                                text = 'products-textPayrollWelcome';
                                accountType = 5;
                                break;

                            case 'products-homeAbroadDebitCard':
                                title = formatText(product.description);
                                text = 'products-textAtHome';
                                accountType = 3;
                                break;

                            case 'products-openDebitCardOthers':
                                title = formatText('products-openDebitCard');
                                text = 'products-textOpenDebit';
                                break;

                            case 'products-openCreditCard':
                                title = formatText(product.description);
                                text = 'products-textOpenCredit';
                                accountType = 4;
                                creditCardPrecontractual = product.url;
                                break;

                            case 'products-valuesAccount':
                                title = formatText(product.description);
                                text = 'products-textValues';
                                break;

                            case 'products-maestroDebitCard':
                                title = formatText(product.description);
                                text = 'products-textOpenDebit';
                                break;
                            case 'products-openDeposit':
                                title = formatText(product.description);
                                text = 'products-textOpenDeposit';
                                break;
                            case 'products-openPaidAccount':
                                title = formatText(product.description);
                                text = 'products-textOpenPaidAccount';
                                break;
                            default:
                                title = formatText(product.description);
                                text = 'products-textDefault';
                        }

                        if (id === 0) {
                            productsDescription = title;
                            productsDescriptionOpenCredit = productsDescription;
                        } else if (description !== 'products-openCreditCard') {
                            productsDescription = productsDescription + ' + ' + title;
                            productsDescriptionOpenCredit = productsDescription;
                        } else {
                            productsDescriptionOpenCredit = productsDescription + ' + ' + title;
                        }

                        products = products.push(
                            Immutable.Map({
                                id: id,
                                description: title,
                                text: text,
                                url: product.url,
                                priority: product.priority,
                                cardDesignUrl: cardDesignUrl,
                            }).toObject()
                        );

                        id++;
                    });
                }

                let newState = {
                    productsDescription,
                    products,
                    accountType,
                    creditCardPrecontractual,
                    productsDescriptionOpenCredit,
                };

                if (action.data.invite) {
                    newState.invite = action.data.invite;
                    let productDesc = formatText('products-openCurrentAccount');
                    if (action.data.invite.openDebitCard) {
                        productDesc += ' + ' + formatText('products-openDebitCard');
                    }
                    newState.productsDescription = productDesc;
                }

                return state.merge(newState);
            }
            break;
        case actionTypes.CLEAR_PRODUCTS:
            const creditCardPrecontractual = state.get('creditCardPrecontractual');
            return state.merge({
                productsDescription: null,
                products: [],
                creditCardPrecontractual,
                productsDescriptionOpenCredit: null,
            });
        case actionTypes.UPDATE_PRODUCTS:
            if (action.data) {
                const credit = state.get('products').findIndex(i => {
                    if (i.text === 'products-textOpenCredit') {
                        return true;
                    }
                });
                const productsDescription = state.get('productsDescription');
                let productsDescriptionOpenCredit = state.get('productsDescriptionOpenCredit');
                let products = state.get('products');
                let dataProducts = action.data.products;
                let accountType = 0;
                let creditCardPrecontractual = state.get('creditCardPrecontractual')
                    ? state.get('creditCardPrecontractual')
                    : null;
                let id = 0;

                dataProducts.forEach(product => {
                    const description = product.description;
                    const cardDesignUrl = product.cardConfig ? product.cardConfig.cardDesignUrl : null;

                    if (description === 'products-openCreditCard') {
                        creditCardPrecontractual = product.url;

                        products = products.push(
                            Immutable.Map({
                                id: id,
                                description: formatText(product.description),
                                text: 'products-textOpenCredit',
                                url: product.url,
                                priority: product.priority,
                                cardDesignUrl: cardDesignUrl,
                            }).toObject()
                        );
                        productsDescriptionOpenCredit = productsDescriptionOpenCredit + ' + ' + formatText(description);
                    }

                    id += 1;
                });

                if (credit !== -1) {
                    products = state.get('products').delete(credit);
                    productsDescriptionOpenCredit = productsDescription;
                }

                let newState = {
                    productsDescription,
                    products,
                    accountType,
                    creditCardPrecontractual,
                    productsDescriptionOpenCredit,
                };

                if (action.data.invite) {
                    newState.invite = action.data.invite;
                }

                return state.merge(newState);
            }
            break;
        case actionTypes.LOAD_PARTNER:
            return state.merge({ partner: action.data });
        default:
            return state;
    }
};

module.exports = products;
